import { createSlice } from "@reduxjs/toolkit";
import {
  fetchModules,
  fetchAllSubmodules,
  fetchSubmodules,
  fetchReports,
  fetchTableViews,
} from "@/apis/config/configApi";

const configSlice = createSlice({
  name: "config",
  initialState: {
    configFieldsEnabled: false,
    configModules: null,
    allSubModules: null,
    configSubModules: null,
    linkedObjects: null,
    refLists: null,
    questionnaires: null,
    globalClientParam: null,
    reports: null,
    tablesViewsNew: null,
    scheduledReports: null,
    feeDescriptions: null,
    actionPaneDivs: null,
    exportTargets: null,
    holidays: null,
    storedProcedures: null,
    stickyFields: null,
    mileageRate: null,
    trainningCourses: null,
    tableNames: null,
    configDefaults: null,
  },
  reducers: {
    setConfigFieldsEnabled: (state, action) => {
      state.configFieldsEnabled = action.payload;
    },
    setConfigModules: (state, action) => {
      state.configModules = action.payload;
    },
    setConfigSubModules: (state, action) => {
      state.configSubModules = action.payload;
    },
    setLinkedObjects: (state, action) => {
      state.linkedObjects = action.payload;
    },
    setRefLists: (state, action) => {
      state.refLists = action.payload;
    },
    setQuestionnaires: (state, action) => {
      state.questionnaires = action.payload;
    },
    setGlobalClientParam: (state, action) => {
      state.globalClientParam = action.payload;
    },
    setReports: (state, action) => {
      state.reports = action.payload;
    },
    setTablesViewsNew: (state, action) => {
      state.tablesViewsNew = action.payload;
    },
    SetScheduledReports: (state, action) => {
      state.scheduledReports = action.payload;
    },
    setFeeDescriptions: (state, action) => {
      state.feeDescriptions = action.payload;
    },
    setActionPaneDivs: (state, action) => {
      state.actionPaneDivs = action.payload;
    },
    setExportTargets: (state, action) => {
      state.exportTargets = action.payload;
    },
    setHolidays: (state, action) => {
      state.holidays = action.payload;
    },
    setStoredProcedures: (state, action) => {
      state.storedProcedures = action.payload;
    },
    setStickyFields: (state, action) => {
      state.stickyFields = action.payload;
    },
    setMileageRate: (state, action) => {
      state.mileageRate = action.payload;
    },
    setTrainningCourses: (state, action) => {
      state.trainningCourses = action.payload;
    },
    setConfigDefaults: (state, action) => {
      state.configDefaults = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchModules.fulfilled, (state, action) => {
        state.configModules = action.payload;
      })
      .addCase(fetchAllSubmodules.fulfilled, (state, action) => {
        state.allSubModules = action.payload;
      })
      .addCase(fetchSubmodules.fulfilled, (state, action) => {
        state.configSubModules = action.payload;
      })
      .addCase(fetchReports.fulfilled, (state, action) => {
        state.reports = action.payload;
      })
      .addCase(fetchTableViews.fulfilled, (state, action) => {
        state.tablesViewsNew = action.payload;
      });
  },
});

export const {
  setConfigFieldsEnabled,
  setConfigModules,
  setConfigSubModules,
  setLinkedObjects,
  setRefLists,
  setQuestionnaires,
  setGlobalClientParam,
  setReports,
  setTablesViewsNew,
  SetScheduledReports,
  setFeeDescriptions,
  setActionPaneDivs,
  setExportTargets,
  setHolidays,
  setStoredProcedures,
  setStickyFields,
  setMileageRate,
  setTrainningCourses,
  setConfigDefaults,
} = configSlice.actions;
export default configSlice.reducer;
